const track = "cui-toggle-track-76xo";
const knob = "cui-toggle-knob-z0tx";
const wrapper = "cui-toggle-wrapper-xmwm";
const label = "cui-toggle-label-zrlu";
const classes = {
  track,
  knob,
  wrapper,
  label
};
export {
  classes as default,
  knob,
  label,
  track,
  wrapper
};
